import { getLang } from 'src/lang';

const baseUrl = '/support';

export const routes = {
  HOME: baseUrl + '/',
  HELPFORM: baseUrl + '/helpform',
  FEEDBACKFORM: baseUrl + '/feedbackform',
  FAQMAIN: baseUrl + '/faq/main',
  FAQSELECTION: baseUrl + '/faq/selection',
  FAQ: baseUrl + '/faq/:id',

  FAQCUSTOMER: baseUrl + '/faqsubcategory/:id',
  FAQSUBCATEGORY: baseUrl + '/faqsubcategory/:idCategory',

  FAQCONTENT: baseUrl + '/faqcontent/:idCategory/:idSubCategory'
};

export const initialState = {
  uuid: '',
  caseStatus: {
    state: '',
    publicSPID: undefined,
    success: false
  },
  coBranding: null,
  maintenance: false,
  feedbackBoxVisible: false
};

export const links = {
  contact: routes.HELPFORM,
  faq: routes.FAQMAIN,
  twitter: 'https://twitter.com/NiceToNectYou',
  instagram: 'https://www.instagram.com/nect'
};

export const getPrivacyLink = () =>
  `https://nect.com/${getLang()}/data-protection/`;

export const getImprintLink = () => `https://nect.com/${getLang()}/imprint/`;
export const getLegalLink = () => `https://nect.com/${getLang()}/legal-notice/`;
export const getAboutLink = () => `https://nect.com/${getLang()}/team/`;
